import { sliderPropsSchema } from '../component-catalog.js';
export const sliderDefinition = {
    type: 'Slider',
    category: 'interactive',
    propsSchema: sliderPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Numeric range slider input. Props: min (required), max (required), value?, step?, label?.',
};
//# sourceMappingURL=Slider.js.map